export default "__VITE_ASSET__559090da__"